module.exports = __webpack_public_path__ + "static/img/report_legend_01.ecc626e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/report_legend_01.png
// module id = 727
// module chunks = 1